import React, { useMemo } from 'react';
import classnames from 'classnames';
import moment from 'moment';

import type { IBaseProps } from '@home/types/common';

import './index.scss';

interface ITimeLineProps extends IBaseProps {
  year: string;
}

const FIXED_ARR = Array.from({ length: 4 });

const TimeLine: React.FC<ITimeLineProps> = (props) => {
  const { className, style, year = '' } = props;

  const isCurrentYear = useMemo(() => moment()?.format('YYYY') === year, [year]);

  return (
    <div style={style} className={classnames('dbg-studio-overall-management-time-line-container', className)}>
      <section className="time-line-time-item">
        <section className="time-line-stepper-item">
          <i className="time-line-stepper-item-dot"></i>
          <span className="time-line-stepper-item-line"></span>
        </section>
        <section className="time-line-label-item">
          <span>Studio</span>
        </section>
      </section>
      {FIXED_ARR.map((_, i) => (
        <section key={i} className="time-line-time-item">
          <section className="time-line-stepper-item">
            <i
              style={{ backgroundColor: isCurrentYear && moment().quarter() === i + 1 ? '#006EFF' : '#BBBBBB' }}
              className="time-line-stepper-item-dot"
            ></i>
            <span className="time-line-stepper-item-line"></span>
          </section>
          <section className="time-line-label-item">
            <span>{year ? `${year}.Q${i + 1}` : '-'}</span>
          </section>
        </section>
      ))}
    </div>
  );
};

export default React.memo(TimeLine);
